module.exports = __webpack_public_path__ + "static/Country_Neighbors.942bb8d4.webm";


//////////////////
// WEBPACK FOOTER
// ./src/img/Country_Neighbors.webm
// module id = 360
// module chunks = 35783957827783